import { ArticleDTO, BookingSummaryDTO, InternationalStringDTO } from "../../apiclient/ApiDtos";
import { SearchFormModel } from "../../components/SearchForm";
import { LocationType } from "../../models/SearchCriteria";

interface ArticleToLoad {
    slug: string,
    title: InternationalStringDTO
}

export class HomeFsmContext {
    constructor(
        public readonly searchFormModel: SearchFormModel,
        public readonly isSearchingSmallCar: boolean,
        public readonly selectingLocationType: LocationType | null = null,
        public readonly articleToLoad: ArticleToLoad | null = null,
        public readonly article: ArticleDTO | null = null,
        public readonly myBookings: BookingSummaryDTO[] | null = null
    ) { }

    withArticleToLoad(slug: string, title: InternationalStringDTO) {
        let articleToLoad = {
            slug: slug,
            title: title
        }
        console.log("build load", articleToLoad);
        return new HomeFsmContext(this.searchFormModel, this.isSearchingSmallCar, null, articleToLoad, null, this.myBookings);
    }

    withArticle(article: ArticleDTO) {
        return new HomeFsmContext(this.searchFormModel, this.isSearchingSmallCar, null, this.articleToLoad, article, this.myBookings);
    }

    withMyBookings(bookings: BookingSummaryDTO[]) {
        return new HomeFsmContext(this.searchFormModel, this.isSearchingSmallCar, null, this.articleToLoad, this.article, bookings);
    }

    withBookingCategoryChanged(isSearchingSmallCar: boolean, updatedSearchFormModel: SearchFormModel) {
        return new HomeFsmContext(
            updatedSearchFormModel, isSearchingSmallCar, null, this.articleToLoad, this.article, 
            this.myBookings
        );
    }

}